export default __webpack_public_path__ + "static/media/tik-tok.8bb71cc6.png";